<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Proje</h3>
          </div>
          <div>
           
          </div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    <a
                      :href="'#/projects'"
                      class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                    >
                      <i class="la la-angle-left"></i>
                    </a>
                    Proje Ekle
                  </h3>
                </div>
              </div>
            </div>

            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Proje Kodu</label>
                    <input type="text"  :class="{ 'is-invalid': $v.project.code.$error }" v-model="project.code" class="form-control m-input" placeholder="Proje kodunu giriniz." />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Açıklama</label>
                    <textarea  :class="{ 'is-invalid': $v.project.description.$error }" class="form-control m-input" v-model="project.description" placeholder="Proje açıklamasını giriniz." id="exampleTextarea" rows="3"></textarea>
                  </div>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button type="button" @click="project.id==0?create():update()" class="spbtn">Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import {_create,_getById,_update} from '../../services/ProjectService'

export default {
created() {
  if(Number(this.$route.params.id)!=0)
        {
          this.project.id=Number(this.$route.params.id);
              this.getById();
        }
},

  data() {
    return {
      project:{
        id:0,
        code:'',
        description:'',
      }
    }
  },
    validations: {
    project: {
      code: { required },
           description: { required }
    }
  },
methods: {
  create:function(){
          this.$v.project.$touch();
      if (this.$v.project.$error) return;
          // let loader=this.$loading.show();
    _create(this.project).then(response=>{
      // loader.hide();
      if(response.data.success)
        this.$router.push({ name: 'projects' })
    });
  },
  update:function(){
          this.$v.project.$touch();
      if (this.$v.project.$error) return;
    _update(this.project).then(response=>{
      if(response.data.success)
        this.$router.push({ name: 'projects' })
    });
  },
  getById:function(){
    _getById(Number(this.$route.params.id)).then(response=>{
      if(response.data.success)
      this.project=response.data.data;
      else
      this.$router.push({ name: 'projects' })
    })
  }
},
};
</script>